import { Modal } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';
import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const PrimaryChangeModal = ({ isOpen, currentLocation, nextLocation, onCancel, onConfirm }) => {
  return (
    <Modal open={isOpen} maxWidth="sm" data-testid="rider-location-change-default-modal">
      <Modal.Title>Change Default Location</Modal.Title>
      <Modal.Content>
        <PrimaryChangeContent>
          {'Are you sure? This will remove default status for this rider from '}
          <span>{currentLocation}</span> {' and will set '} <span>{nextLocation}</span>
          {' as the default address. Existing ride series will not be affected.'}
        </PrimaryChangeContent>
      </Modal.Content>
      <Modal.Actions>
        <Button color="tertiary" onClick={onCancel}>
          Cancel
        </Button>
        <Button color="primary" onClick={onConfirm}>
          Change
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const PrimaryChangeContent = styled.p`
  font-weight: 300;
  color: ${colorTokens.text.medium};

  span {
    font-weight: 500;
    color: ${colorTokens.text.dark};
  }
`;
